export const contentTableConfig = {
  title: '复播视频列表',
  propList: [
    { prop: 'title', label: '标题', minWidth: '120' },
    { prop: 'cover', label: '封面', minWidth: '80', slotName: 'cover' },
    { prop: 'url', label: '访问地址', minWidth: '60', slotName: 'url' },
    { prop: 'id', label: '复制链接', minWidth: '60', slotName: 'generate' },
    { prop: 'teacherName', label: '老师名', minWidth: '60' },
    { prop: 'courseName', label: '课程名', minWidth: '80' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '80',
      slotName: 'createdTime'
    },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
